<template>
  <div>
    <o-section :overlay="true">
      <p>Geef aan hoe ver u met de elektrische wagen wil rijden.</p>
      <o-text-input label="Aantal kilometer" placeholder="0" type="number" />
    </o-section>
  </div>
</template>

<script>
export default {
  name: 'OEditDistance'
}
</script>
